$(document).ready(function(){

    //Handle Advanced Product Options - height and width
    //Limit to 5 increments and make number
    $("body").on("click", ".custom-number-five input[type=text]", function(){
        //make number (default is text)
        $(this).attr("type", "number")
    })
    $("body").on("change", ".custom-number-five input", function(){
        var parent = $(this).closest(".custom-number-five")
        var parsed_value = parseInt($(this).val())
        var min
        var max

        for (let i = 0; i < parent[0].classList.length; i++) {
            const element = parent[0].classList[i];
            console.log(element)
            //get min and max from class list
            if(element.includes("min--")){
                //get min value that is passed through backend
                min = parseInt(element.split("min--")[1])
            }
            //get min and max from class list
            if(element.includes("max--")){
                //get min value that is passed through backend
                max = parseInt(element.split("max--")[1])
            }
        }

        //check to see if within min max bounds
        if(parsed_value < min){
            $(this).val(min)
        }else if(parsed_value > max){
            $(this).val(max)
        }else{
            var rounded_value = Math.round(parsed_value/5)*5
            $(this).val(rounded_value) //Round input to the nearest 5
        }
    })
})